module.exports = __webpack_public_path__ + "static/icons/site.webmanifest";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/site.webmanifest
// module id = F5+a
// module chunks = 0